import React from 'react';

export const UnitText: React.FC<
    React.PropsWithChildren<{
        text: string;
    }>
> = (props) => {
    return <span style={{ fontSize: '80%' }}>{props.text}</span>;
};
